import React, {useState} from 'react';
import OnboardingDashboardCard from './OnboardingDashboardCard';
import BasicHighchartGraph from '../../Graph/BasicHighchartGraph';
import moment from "moment";
import {createOnboardingGraphSettings, createOnboardingSummaryGraphSettings} from '../../../componentObjects';


function AssetTrainingHistoryCard(props) {
    const { assetType, onboardInfo, onTrainingHistoryClick, isSummary = false } = props;

    let onboardingChartData = isSummary ? createOnboardingSummaryGraphSettings() : createOnboardingGraphSettings(assetType);
    
    const getChartItem = (dataArray, chartData, pointStartMoment) => {
        let trendData = {
            name: chartData.name,
            data: dataArray,
            color: chartData.color,
            dashStyle: 'solid',
            type: 'line',
            pointStart: pointStartMoment,
            pointInterval: 24 * 3600 * 1000,
            opacity: 1,
            marker: {
                enabledThreshold: 0
            }
        };

        return trendData;
    }

    const getChartData = (data) => {
        let chartDataList = [];

        if (data !== undefined && data.length) {
            let pointMoment = moment(data[0].Timestamp).add(moment().utcOffset() * -1, 'minutes').format("l")
            let dt = new Date(pointMoment);
            let pointStartMoment = Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds());

            let trainedArr = data.map((item) => (item.Trained));
            const trainedData = getChartItem(trainedArr, onboardingChartData.trained, pointStartMoment);
            chartDataList = chartDataList.concat(trainedData);

            let failedArr = data.map((item) => (item.Failed));
            const failedData = getChartItem(failedArr, onboardingChartData.failed, pointStartMoment);
            chartDataList = chartDataList.concat(failedData);

            let notEnoughDataArr = data.map((item) => (item.NotEnoughData));
            const notEnoughDataData = getChartItem(notEnoughDataArr, onboardingChartData.notEnoughData, pointStartMoment);
            chartDataList = chartDataList.concat(notEnoughDataData);

        }

        return chartDataList;
    }
    
    const getAssetChartSummary = (chartDataList, assetChartData, data) => {
        if (data !== undefined && data.length) {
            let pointMoment = moment(data[0].Timestamp).add(moment().utcOffset() * -1, 'minutes').format("l")
            let dt = new Date(pointMoment);
            let pointStartMoment = Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds());

            let trainedArr = data.map((item) => (item.Trained));
            const trainedData = getChartItem(trainedArr, assetChartData.trained, pointStartMoment);
            chartDataList = chartDataList.concat(trainedData);

            let failedArr = data.map((item) => (item.Failed));
            const failedData = getChartItem(failedArr, assetChartData.failed, pointStartMoment);
            chartDataList = chartDataList.concat(failedData);

            let notEnoughDataArr = data.map((item) => (item.NotEnoughData));
            const notEnoughDataData = getChartItem(notEnoughDataArr, assetChartData.notEnoughData, pointStartMoment);
            chartDataList = chartDataList.concat(notEnoughDataData);
        }
        return chartDataList;
    }
    
    const getSummaryChartData = (dataDict) => {
        let chartDataList = [];

        if (dataDict !== undefined && dataDict !== null) {
            if (dataDict.Furnace !== undefined && dataDict.Furnace.length) {
                let furnaceChartDataList = getAssetChartSummary(chartDataList, onboardingChartData.furnace, dataDict.Furnace);
                chartDataList = chartDataList.concat(furnaceChartDataList);
            }
            if (dataDict.AirConditioner !== undefined && dataDict.AirConditioner.length) {
                chartDataList = getAssetChartSummary(chartDataList, onboardingChartData.air_conditioner, dataDict.AirConditioner);
            }
            if (dataDict.AirHandler !== undefined && dataDict.AirHandler.length) {
                chartDataList = getAssetChartSummary(chartDataList, onboardingChartData.air_handler, dataDict.AirHandler);
            }
            if (dataDict.HeatPump !== undefined && dataDict.HeatPump.length) {
                chartDataList = getAssetChartSummary(chartDataList, onboardingChartData.heat_pump, dataDict.HeatPump);
            }
        }
        return chartDataList;
    }
    
    let chartData = isSummary ? getSummaryChartData(onboardInfo.trainingGraphDataDict) : getChartData(onboardInfo.trainingGraphData); 
    
    let trainingHistoryContent = 
    <div className="row no-gutters card-row text-center min-height-110">
        <div className="col min-height-110">
            <BasicHighchartGraph chartData={chartData} yAxisTitle='Asset Count' />
        </div>
    </div>

    return (
        <div className="col-6">
            <div>
                <OnboardingDashboardCard title={'Asset Training History'} content={trainingHistoryContent} onClick={onTrainingHistoryClick} isGraphCard={true}/>
            </div>
        </div>
    );
}

export default AssetTrainingHistoryCard;